import { render, staticRenderFns } from "./StockChange.vue?vue&type=template&id=29a23a76&scoped=true&"
import script from "./StockChange.vue?vue&type=script&lang=js&"
export * from "./StockChange.vue?vue&type=script&lang=js&"
import style0 from "./StockChange.vue?vue&type=style&index=0&id=29a23a76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a23a76",
  null
  
)

export default component.exports